import Vue from "vue";
import Vuex from "vuex";
import createCache from "vuex-cache";

// modules
import deviceReport from "./modules/deviceReport";
import user from "./modules/user";
import group from "./modules/group";
import organization from "./modules/organization";
import licensePool from "./modules/licensePool";
import product from "./modules/product";
import dashboard from "./modules/dashboard";
import task from "./modules/task";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [createCache()],
  modules: {
    deviceReport,
    user,
    group,
    organization,
    licensePool,
    product,
    dashboard,
    task
  }
});

export default store;
